import { FaqAccordionItems } from '@app/widgets';

export const PRICING_FAQS: FaqAccordionItems[] = [
  {
    question: 'What are Live Updates and how are they counted?',
    answer: [
      'Live Updates allow you to deploy updates to your Capacitor app without going through app store reviews.',
      'Each time a device downloads an update bundle, it counts as one Live Update.',
      'The limit resets at the beginning of each month.',
    ].join(' '),
  },
  {
    question: 'What are Build Minutes?',
    answer: [
      'Build Minutes represent the total compute time used to build your iOS and Android apps in the cloud.',
      'For example, if a build takes 5 minutes, it consumes 5 Build Minutes from your monthly quota.',
      'On average, a Capacitor app build takes 3-5 minutes, so 1,000 Build Minutes equals approximately 200-300 builds.',
      'The limit resets at the beginning of each month.',
    ].join(' '),
  },
  {
    question: 'What are Concurrent Builds?',
    answer: [
      'Concurrent Builds determine how many builds can run simultaneously.',
      'For example, with 2 Concurrent Builds, you can build your iOS and Android apps at the same time.',
      'This significantly speeds up your CI/CD pipeline when building for multiple platforms.',
    ].join(' '),
  },
  {
    question: 'What is Data Retention?',
    answer: [
      'Data Retention determines how long your build artifacts, logs, and update bundles are stored.',
      'For example, with 60 Days Data Retention, you can access and download your builds and bundles for up to 60 days after creation.',
      'After the retention period, unused artifacts are automatically deleted to free up storage space.',
    ].join(' '),
  },
  {
    question: 'What happens if I reach my plan limits?',
    answer: [
      'If you reach one of your plan limits, such as Live Updates or Build Minutes, you will be notified via email.',
      'You can choose to upgrade your plan to increase your limits or wait until the next billing cycle when your limits reset.',
      'Upgrading your plan takes effect immediately, and you will be prorated for the remaining billing period.',
    ].join(' '),
  },
  {
    question: 'Can I change my plan at any time?',
    answer: [
      'Yes, you can upgrade or downgrade your plan at any time from your billing settings.',
      'When you upgrade, the changes take effect immediately, and you will be prorated for the remaining billing period.',
      'When you downgrade, the changes take effect at the start of your next billing cycle.',
    ].join(' '),
  },
  {
    question: 'What payment methods do you accept?',
    answer: [
      'We accept all major credit cards, including Visa, MasterCard, and American Express.',
      'We also support PayPal for added convenience.',
      'All payments are processed securely through our payment partners Lemon Squeezy and Polar.',
      'For Enterprise plans, we can also accommodate invoicing and bank transfers upon request.',
    ].join(' '),
  },
  {
    question: 'Are there any setup fees or hidden costs?',
    answer: [
      'No, there are no setup fees, activation fees, or hidden costs.',
      'The price you see is the price you pay - we believe in transparent pricing.',
      'You only pay for what you use based on your selected plan.',
      'Even our Enterprise plans have no hidden fees - all costs are discussed upfront.',
    ].join(' '),
  },
  {
    question: 'Can I cancel my plan at any time?',
    answer: [
      'Yes, you can cancel your plan at any time from your billing settings.',
      'When you cancel, your plan will remain active until the end of your current billing cycle.',
      'After that, your account will be downgraded to the free plan, and you will lose access to any features that are not included in the free plan.',
      'You will not be charged again unless you decide to upgrade to a paid plan in the future.',
    ].join(' '),
  },
];
